<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Feedback" description="Aimz"/>
      <header1 class="mt-10">Feedback</header1>
      <v-row class="ml-5 mt-5" style="min-height: 40px;" v-if="changed">
        <v-btn dark @click="save">Speichern</v-btn>
        <v-btn class="ml-3" @click="load">Abbrechen</v-btn>
      </v-row>
      <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
      <v-alert type="error" v-if="error">{{ reason }}</v-alert>
      <v-col class="mx-2 mt-3">
        <v-checkbox v-model="settings_edited.requestFeedbackEnabled" label="Feedback einholen"/>
        <div class="d-flex">
          <v-select label="Wochentag" prepend-icon="mdi-calendar" v-model="settings_edited.requestDay" :items="dayOptions"/>
          <v-text-field class="ml-3" v-model="settings_edited.requestFeedbackAt" label="Täglich ca. um"></v-text-field>
        </div>
        <p class="body-2">
          Von den folgenden Kontakten wird {{settings_edited.requestDay || 'gewählten Wochentag'}} ab {{settings_edited.requestFeedbackAt || 'zur gewählten Zeit'}} innerhalb von 15min. Feedback per Email angefordert:
        </p>
        <div class="d-flex" v-for="(item,i) in settings_edited.requestEmails">
          <v-text-field class="ml-0" v-model="item.email" :label="'Email '+(i+1)" :key="i"
           prepend-icon="mdi-email" :rules="emailRules"/>
          <v-btn v-if="item.email" @click="onRequestNow(item.email)" class="ml-3 mt-3">
            <v-icon>mdi-comment-quote-outline</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";
import Lib from "@/components/ActivityLibrary";

const SETTINGS_CONTEXT = "@feedback";

export default {
  name: 'FeedbackSettings',
  components: {CenterContainer, Header1},
  data() {
    return {
      emailRules: [
        //v => !!v || 'Bitte ausfüllen',
        v => /.+@.+/.test(v) || 'Ungültige Email',
      ],
      settings: {},
      settings_edited: {
        requestEmails: [{email:undefined}],
      },
      loading: false,
      reason: '',
      error: false,
      changed: false,
      dayOptions: [Lib.INPUT_MO, Lib.INPUT_DI, Lib.INPUT_MI, Lib.INPUT_DO, Lib.INPUT_FR, Lib.INPUT_SA, Lib.INPUT_SO],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$backend.get_settings(SETTINGS_CONTEXT, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
    },
    onLoadSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
      this.updateEmails();
    },
    onLoadError(reason) {
      this.loading = false;
      this.settings = {};
      this.error = true;
      this.reason = reason;
      this.updateEmails();
    },
    save() {
      this.loading = true;
      this.$backend.set_settings(SETTINGS_CONTEXT, this.settings_edited, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    updateEmails(){
      var n=this.settings_edited;
      if (!n.requestEmails || n.requestEmails.length==0)
        this.$set(n, 'requestEmails', [{email:undefined}]);
      console.log("last email:", n.requestEmails[n.requestEmails.length-1].email)
      if (n.requestEmails[n.requestEmails.length-1].email)
        n.requestEmails.push({email:undefined});
    },
    onRequestNow(email) {
      this.$backend.request_feedback(email );
    }
  },
  computed: {},
  watch: {
    settings_edited: {
      deep: true,
      handler(o, n) {
        this.changed = JSON.stringify(this.settings) !== JSON.stringify(this.settings_edited);
        this.updateEmails();
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>